import UiForm from "./UiForm";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import DtoFormJoinCompanyUser_JoinCompanyUserGroup from "./DtoFormJoinCompanyUser_JoinCompanyUserGroup";
import UiGroup from "./UiGroup";

/**
 * 关联-公司/用户表单
 * @description 自动生成的代码,请勿修改
 */
export default class DtoFormJoinCompanyUserReadGroup extends UiForm<string> {
    constructor() {
        //无参构造函数
        super()
        this.JoinCompanyUserReadGroups = [];
        this.UiGroups = [];
    }

    [proName: string]: any;
    /**
     * 财务监察
     */
    JoinCompanyUserReadGroups?: DtoFormJoinCompanyUser_JoinCompanyUserGroup[];
}

/**
 * 关联-公司/用户表单-表单校验
 */
export const DtoFormJoinCompanyUserReadGroupRules = {
}

/**
 * 关联-公司/用户表单-设置项
 */
export const DtoFormJoinCompanyUserReadGroupMiezzFormItems: MiezzFormItem[] = [
  {
    Prop: "JoinCompanyUserReadGroups",
    Label: "财务监察",
    Customize: true,
  },
]
